import React, { memo } from "react";
import { accountFeatures, useSSelector } from "../util";
import { ReportComponentProps } from "./Report";
import {
  SectionProperty,
  SectionGrowth,
  SectionHeight,
  SectionNature,
  SectionSoil,
  SectionFacts,
} from "./sections";
import { RestrictedContent } from "./RestrictedContent";

const ReportFR = ({ section = "" }: ReportComponentProps) => {
  const { account, field, bunder } = useSSelector(({ selection, activeUser }) => ({
    account: activeUser.account,
    field: selection.field,
    bunder: selection.bunder,
  }));
  const cropfield = field?.state === "fetched" ? field.feature : bunder,
    smallScreen = window.innerWidth < 768,
    features = accountFeatures(account);
  const p = { features, field, cropfield, smallScreen };

  return (
    <main className="sections">
      <SectionFacts
        active={!section || section === "facts"}
        features={features}
        smallScreen={smallScreen}
        cropfield={cropfield}
        field={field}
      />
      <SectionSoil size="" active={section === "soil"} {...p} />
      <SectionProperty active={section === "property"} {...p} />
      <SectionGrowth
        active={section === "growth"}
        inView={["property", "growth", "height"].includes(section)}
        {...p}
      />
      <SectionHeight
        active={section === "height"}
        inView={["property", "growth", "height"].includes(section)}
        names={["1", "2", "3"]}
        labels={["2010", "2015", "2021"]}
        defaultVersion={features.pro ? "3" : "1"}
        {...p}
      />
      <SectionNature active={section === "nature"} {...p} />
      <section id="section_last" />
    </main>
  );
};

const m = memo(({ section = "" }: ReportComponentProps) => (
  <RestrictedContent Component={ReportFR} section={section} />
));

export { m as ReportFR };
